/* La Manufacture Gourmande — Immersion : animations & transitions d'univers */
(function () {
  'use strict';
  var d = document, html = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var UCOL = { mer: ['#06324f', '#eaf6f4', 'La Mer'], terre: ['#6e2a1c', '#fbeedc', 'La Terre'], vege: ['#234d33', '#f2f6e4', 'Le Végétal'], panisse: ['#f2c14e', '#2a1d0b', 'Les Panisses'], brand: ['#00167a', '#f8f4ec', ''] };
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* ---------- Univers d'une URL ---------- */
  function uOfHref(href) {
    if (/\/collections\/raviolis-mer/.test(href)) return 'mer';
    if (/\/collections\/raviolis-terre/.test(href)) return 'terre';
    if (/\/collections\/raviolis-vegetariens/.test(href)) return 'vege';
    if (/\/collections\/panisses/.test(href)) return 'panisse';
    return null;
  }

  /* ---------- Intro (1re visite de la session) ---------- */
  function intro(done) {
    var el = $('.lmg-intro');
    if (!el || reduce || store('lmg-intro')) { html.classList.add('no-intro'); done(); return; }
    store('lmg-intro', '1');
    d.body.style.overflow = 'hidden';
    setTimeout(function () {
      el.classList.add('is-out');
      d.body.style.overflow = '';
      setTimeout(done, 350);
      setTimeout(function () { el.remove(); }, 1100);
    }, 1900);
  }

  /* ---------- Rideau « portail » entre pages ---------- */
  var curtain = $('.lmg-curtain');
  function arrive() {
    if (!curtain) return;
    if (html.classList.contains('is-arriving')) {
      try { var c = JSON.parse(store('lmg-curtain') || 'null'); var lbl = $('.lmg-curtain__label', curtain); if (c && lbl) lbl.textContent = c[2] || ''; } catch (e) {}
      setTimeout(function () {
        curtain.classList.add('is-opening');
        html.classList.remove('is-arriving');
        setTimeout(function () { curtain.classList.remove('is-opening'); curtain.style.removeProperty('--curtain'); }, 950);
      }, 260);
    }
    store('lmg-curtain', null);
  }
  function leave(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || reduce || !curtain) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.dataset.noTransition !== undefined) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.hash) return;
    if (/^\/(cart|account|checkout)/.test(url.pathname) || url.protocol.indexOf('http') !== 0) return;
    e.preventDefault();
    var u = a.dataset.go || uOfHref(url.pathname) || 'brand';
    var c = UCOL[u] || UCOL.brand;
    curtain.style.setProperty('--curtain', c[0]);
    curtain.style.setProperty('--curtain-ink', c[1]);
    curtain.style.setProperty('--cx', e.clientX + 'px');
    curtain.style.setProperty('--cy', e.clientY + 'px');
    var lbl = $('.lmg-curtain__label', curtain); if (lbl) lbl.textContent = c[2];
    curtain.classList.remove('is-opening');
    void curtain.offsetWidth;
    curtain.classList.add('is-closing');
    store('lmg-curtain', JSON.stringify(c));
    setTimeout(function () { location.href = url.href; }, 680);
  }
  w.addEventListener('pageshow', function (ev) { if (ev.persisted && curtain) { curtain.classList.remove('is-closing'); html.classList.remove('is-arriving'); } });

  /* ---------- En-tête ---------- */
  function header() {
    var h = $('.lmg-header'); if (!h) return;
    var last = 0;
    function on() {
      var y = w.scrollY;
      h.classList.toggle('is-solid', y > 40);
      h.classList.toggle('is-hidden', y > 400 && y > last + 4 && !html.classList.contains('menu-open'));
      if (y < last - 4) h.classList.remove('is-hidden');
      last = y;
    }
    w.addEventListener('scroll', on, { passive: true }); on();
    var b = $('.lmg-burger'), m = $('#lmg-menu');
    function setMenu(open) {
      html.classList.toggle('menu-open', open);
      if (b) b.setAttribute('aria-expanded', open);
      if (m) { if (open) m.removeAttribute('inert'); else m.setAttribute('inert', ''); }
      d.body.style.overflow = open ? 'hidden' : '';
    }
    if (b) b.addEventListener('click', function () { setMenu(!html.classList.contains('menu-open')); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && html.classList.contains('menu-open')) { setMenu(false); b && b.focus(); } });
    var wide = w.matchMedia('(min-width: 1280px)');
    function onWide() { if (wide.matches && html.classList.contains('menu-open')) setMenu(false); }
    if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
    w.addEventListener('pageshow', function (ev) { if (ev.persisted) setMenu(false); });
  }

  /* ---------- Apparitions + tracés ---------- */
  function reveals() {
    var els = $$('[data-reveal], .draw-on');
    if (!reduce) $$('.draw-on path, .draw-on circle').forEach(function (p) { p.setAttribute('pathLength', '1'); });
    if (!('IntersectionObserver' in w) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Changement d'univers au scroll (couleur du site) ---------- */
  function zones() {
    var z = $$('[data-u-zone]'); if (!z.length || !('IntersectionObserver' in w)) return;
    var meta = $('meta[name="theme-color"]');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting) {
          var u = x.target.getAttribute('data-u-zone');
          d.body.setAttribute('data-u', u);
          if (meta && UCOL[u]) meta.setAttribute('content', UCOL[u][0] === '#00167a' ? '#f8f4ec' : UCOL[u][0]);
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    z.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Portails (cercle qui s'ouvre au scroll) + parallaxe ---------- */
  function scrollFx() {
    var ch = $$('.chapter'), par = $$('[data-parallax]'), hero = $('.hero__stage');
    if (reduce) { ch.forEach(function (c) { c.style.setProperty('--p', 1); }); return; }
    var ticking = false, vh = w.innerHeight;
    function f() {
      ticking = false;
      ch.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var p = Math.min(1, Math.max(0.08, (vh - r.top) / (vh * 0.9)));
        c.style.setProperty('--p', p.toFixed(3));
      });
      par.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
        var s = parseFloat(el.dataset.parallax) || 0.15;
        el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -s).toFixed(1) + 'px,0)';
      });
    }
    function q() { if (!ticking) { ticking = true; requestAnimationFrame(f); } }
    w.addEventListener('scroll', q, { passive: true });
    w.addEventListener('resize', function () { vh = w.innerHeight; q(); });
    f();
    if (hero && w.matchMedia('(pointer: fine)').matches) {
      d.addEventListener('mousemove', function (e) {
        var x = (e.clientX / w.innerWidth - 0.5), y = (e.clientY / w.innerHeight - 0.5);
        hero.style.transform = 'translate3d(' + (x * -24) + 'px,' + (y * -24) + 'px,0)';
      });
    }
  }

  /* ---------- Rails horizontaux ---------- */
  function rails() {
    $$('.rail').forEach(function (r) {
      var t = $('.rail__track', r), prev = $('[data-prev]', r), next = $('[data-next]', r), bar = $('.rail__bar span', r);
      if (!t) return;
      function step() { var c = t.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; }
      /* Accueil : les produits visibles restent centrés sur l'écran */
      var foot = $('.rail__foot', r);
      function center() {
        if (!r.closest('.chapter')) return;
        var n = t.children.length; if (!n) return;
        var gap = parseFloat(w.getComputedStyle(t).columnGap) || 20, W = t.clientWidth;
        var g = foot ? parseFloat(w.getComputedStyle(foot).paddingLeft) || 16 : 16;
        var cols = W < 700 ? 1 : W < 1000 ? 3 : 4;
        var cw = cols === 1 ? Math.min(300, Math.round(W * 0.78)) : Math.min(320, Math.floor((W - 2 * g - (cols - 1) * gap) / cols));
        t.style.gridAutoColumns = cw + 'px';
        var k = cols === 1 ? 1 : Math.max(cols, Math.floor((W - 2 * g + gap) / (cw + gap))), m = Math.min(n, k);
        var pad = Math.max(g, Math.floor((W - m * cw - (m - 1) * gap) / 2));
        t.style.paddingLeft = t.style.paddingRight = pad + 'px';
        t.style.scrollPaddingLeft = t.style.scrollPaddingRight = pad + 'px';
        r.classList.toggle('rail--fit', n <= k);
      }
      function upd() {
        var max = t.scrollWidth - t.clientWidth;
        if (prev) prev.disabled = t.scrollLeft < 8;
        if (next) next.disabled = t.scrollLeft > max - 8;
        if (bar) { var vis = t.clientWidth / t.scrollWidth; bar.style.width = (vis * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)'; }
      }
      prev && prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
      t.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', function () { center(); upd(); }); center(); upd();
      var down = false, sx = 0, sl = 0, moved = false;
      t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = t.scrollLeft; });
      w.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; t.classList.add('is-drag'); } t.scrollLeft = sl - dx; });
      w.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { t.classList.remove('is-drag'); }, 0); });
      t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- Filtres de collection (Signature / Exception / Végétarien) ---------- */
  function filters() {
    var bar = $('[data-filters]'); if (!bar) return;
    var cards = $$('[data-tags]');
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-f]'); if (!b) return;
      $$('button[data-f]', bar).forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
      var f = b.dataset.f;
      cards.forEach(function (c) { c.classList.toggle('is-hidden', f !== 'all' && (' ' + c.dataset.tags + ' ').indexOf(' ' + f + ' ') < 0); });
    });
  }

  /* ---------- Fiche produit : vignettes + tilt ---------- */
  function product() {
    var stage = $('.p-stage'); if (!stage) return;
    var img = $('img.p-main-img', stage);
    $$('.p-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.p-thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        if (img) { img.srcset = b.dataset.srcset; img.src = b.dataset.src; }
      });
    });
    if (!reduce && img && w.matchMedia('(pointer: fine)').matches) {
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'perspective(800px) rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 14) + 'deg) scale(1.04)';
      });
      stage.addEventListener('mouseleave', function () { img.style.transform = ''; });
    }
  }

  /* ---------- Formulaire : pré-remplissage produit + profil ---------- */
  function contact() {
    var f = $('#lmg-contact'); if (!f) return;
    var q = new URLSearchParams(location.search);
    var p = q.get('produit'), prof = q.get('profil');
    var prod = $('[name="contact[Produits]"]', f), msg = $('[name="contact[body]"]', f);
    if (p && prod) { prod.value = p; }
    if (p && msg && !msg.value) { msg.value = 'Bonjour, je souhaite recevoir un devis pour : ' + p + '.\n'; }
    if (prof) { var r = $('input[name="contact[Profil]"][value="' + prof + '"]', f); if (r) r.checked = true; }
    if (q.get('demande') === 'plaquette' && msg && !msg.value) { msg.value = 'Bonjour, je souhaite recevoir la plaquette commerciale de La Manufacture Gourmande.\n'; }
  }

  /* ---------- Curseur ---------- */
  function cursor() {
    var c = $('.lmg-cursor'); if (!c || reduce || !w.matchMedia('(pointer: fine)').matches) return;
    var x = 0, y = 0, cx = 0, cy = 0;
    d.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; c.classList.add('is-on'); });
    d.addEventListener('mouseleave', function () { c.classList.remove('is-on'); });
    (function loop() { cx += (x - cx) * 0.2; cy += (y - cy) * 0.2; c.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)'; requestAnimationFrame(loop); })();
    d.addEventListener('mouseover', function (e) {
      var t = e.target.closest && e.target.closest('[data-cursor]');
      c.classList.toggle('is-big', !!t); c.textContent = t ? t.getAttribute('data-cursor') : '';
    });
  }

  /* ---------- Démarrage ---------- */
  html.classList.add('js');
  d.addEventListener('click', leave);
  function boot() {
    header(); reveals(); zones(); scrollFx(); rails(); filters(); product(); contact(); cursor(); arrive();
    intro(function () { html.classList.add('is-ready'); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();